import React from 'react'
import Main from '../Main'
import ServiceBtn from "../Services/ServiceBtn"
import restaurant from "../assets/img/demo1.png"
import BackToService from './BackToService'

function Demo() {
    return (
        <>
            <Main active="service">
                <div className="main">
                    <section>
                        <div className="container section-title">
                            <h2>Other Project's Demo <BackToService /></h2>
                            <div className="row" style={{ "marginTop": "30px" }}>
                                <div className="col-md-3" style={{ "marginTop": "20px" }}>
                                    <div className="service-card">
                                        <img src={restaurant} alt="" className="rounded mx-auto d-block" />
                                        <h5>Restaurant Demo</h5>
                                        <div className="mx-auto" style={{ "textAlign": "center" }}>
                                            <ServiceBtn to="/service/demo/restaurant" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </Main>
        </>
    )
}

export default Demo
